import { Component, Input, OnChanges, inject, ChangeDetectionStrategy } from "@angular/core";
import { NotificationService } from "../../../services/notification.service";
import { FormuleVariableMultichoiceComponent } from "../../formulas/formule-variable-multichoice/formule-variable-multichoice.component";
import { MatDialog } from "@angular/material/dialog";
import { FormulasService } from "../../../services/formulas.service";
import { Formula } from "../../../entities/formula/formula";
import { FormulaVariable } from "../../../entities/formula/formula-variable";
import { NgMathPipesModule } from "ngx-pipes";
import { MatIcon } from "@angular/material/icon";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatInput } from "@angular/material/input";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatButton } from "@angular/material/button";

import { NgxTolgeeModule } from "@tolgee/ngx";

@Component({
	selector: "app-formula-viewer",
	templateUrl: "./formula-viewer.component.html",
	styleUrls: ["./formula-viewer.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		MatButton,
		MatFormField,
		MatLabel,
		MatInput,
		ReactiveFormsModule,
		FormsModule,
		MatIcon,
		MatSuffix,
		NgMathPipesModule,
		NgxTolgeeModule,
	],
})
export class FormulaViewerComponent implements OnChanges {
	private dialog = inject(MatDialog);
	private formulasService = inject(FormulasService);
	private toastr = inject(NotificationService);

	@Input() selectedFormula: Formula = null;
	outputEquation: string = "";
	result: number = null;

	ngOnChanges(): void {
		this.formulasService.formatEquationLabel(this.selectedFormula, this.result);
		this.clearResult();
	}

	loadVariableMultichoice(variable: FormulaVariable) {
		this.dialog
			.open(FormuleVariableMultichoiceComponent, {
				data: variable.choices,
			})
			.afterClosed()
			.subscribe((choice) => {
				if (choice) {
					this.clearResult();
					variable.value = choice.value;
				}
			});
	}

	calculate(): void {
		if (this.selectedFormula == null) {
			this.toastr.warning("Merci de sélectionner une formule !");
		}
		const vars = {};
		for (const variable of this.selectedFormula.variables) {
			if (!variable.value) {
				this.toastr.warning("Merci de renseigner tous les chmaps nécessaires !");
				return;
			}
			if (!Number(variable.value)) {
				this.toastr.warning("Merci de renseigner une valeur numérique.");
				return;
			}
			vars[variable.variable] = variable.value;
		}
		if (Object.keys(vars).length !== this.selectedFormula.variables.length) {
			return;
		}
		try {
			this.result = this.formulasService.calculate(this.selectedFormula, vars);
			this.outputEquation = this.formulasService.formatEquationLabel(this.selectedFormula, this.result);
		} catch (e) {
			this.toastr.error(e);
		}
	}

	clearResult(): void {
		this.result = null;
	}
}
